function plugin (Vue, options) {
    // Exit if the plugin has already been installed.
    if (plugin.installed) return


    var CustomLog = function() {

        var debugObj = this;
        var logLevel = localStorage.getItem("logLevel") || 0;
        var ranid = Math.floor((Math.random() * 100));
        var lastLogTime = new Date();


        var _create = function() {
            if (logLevel != 0) {
                debugObj.log = console.debug.bind(window.console, '[JW'+ranid+']')
            } else {
                debugObj.log = function() {}
            }
        }

        this.logTime = function(msg) {
            var now = new Date();
            var offset = Math.round((now - lastLogTime)/1000);
            lastLogTime = now;

            this.log('TIMELOG',offset,msg);
        }

        this.toggle = function() {
            logLevel = +!parseInt(logLevel);
            localStorage.setItem('logLevel',logLevel);

            _create();

            console.log('[JW'+ranid+']','LOGLEVEL SET TO',logLevel);
        }

        _create();
    }

    let customLog = new CustomLog()

    // Extend `Vue.prototype` to include our global event bus.
    Object.defineProperty(Vue.prototype, '$l', {
        get () {
            return customLog
        }
    })
}




export default plugin


// WEBPACK FOOTER //
// ./src/plugins/custom-log/index.js